import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { EventsAwardsLandingPageContext } from "@events-awards/utils/types";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/SBA/+types/EventsAwardsSBAPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsSBAPageData } from "./EventsAwardsSBAPage.server";
import EventsAwardsSBAPageContent from "./EventsAwardsSBAPageContent";

/** This is the main entry point component for /events-awards/singapore-business-awards route. */
const EventsAwardsSBAPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsLandingPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsSBAPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsSBAPage;

export const loader = async () => await fetchEventsAwardsSBAPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as EventsAwardsLandingPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
